// ------- Profile-Icon ------- //
export const ProfileIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.48131 12.8988C4.30234 13.6008 1.21114 15.0342 3.09389 16.8279C4.01359 17.7041 5.03791 18.3308 6.32573 18.3308H13.6743C14.9621 18.3308 15.9864 17.7041 16.9061 16.8279C18.7888 15.0342 15.6977 13.6008 14.5187 12.8988C11.754 11.2525 8.24599 11.2525 5.48131 12.8988Z"
        stroke="#A7A7A7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 5.41406C13.75 7.48513 12.0711 9.16406 10 9.16406C7.92893 9.16406 6.25 7.48513 6.25 5.41406C6.25 3.343 7.92893 1.66406 10 1.66406C12.0711 1.66406 13.75 3.343 13.75 5.41406Z"
        stroke="#A7A7A7"
        strokeWidth="1.5"
      />
    </svg>
  );
};

// ------- Order-Icon ------- //
export const OrderIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 9.16406C2.5 6.03929 2.5 4.4769 3.29576 3.38162C3.55276 3.0279 3.86383 2.71682 4.21756 2.45982C5.31283 1.66406 6.87522 1.66406 10 1.66406C13.1247 1.66406 14.6872 1.66406 15.7824 2.45982C16.1362 2.71682 16.4472 3.0279 16.7042 3.38162C17.5 4.4769 17.5 6.03929 17.5 9.16406V10.8307C17.5 13.9555 17.5 15.5179 16.7042 16.6131C16.4472 16.9669 16.1362 17.278 15.7824 17.535C14.6872 18.3307 13.1247 18.3307 10 18.3307C6.87522 18.3307 5.31283 18.3307 4.21756 17.535C3.86383 17.278 3.55276 16.9669 3.29576 16.6131C2.5 15.5179 2.5 13.9555 2.5 10.8307V9.16406Z"
        stroke="#A7A7A7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4997 7.91406H5.83301M8.33301 12.0807H5.83301"
        stroke="#A7A7A7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// ------- Wishlist-Icon ------- //
export const WishlistIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.2192 3.32846C13.9844 1.95769 12.034 2.51009 10.8623 3.39001C10.3818 3.7508 10.1417 3.93119 10.0003 3.93119C9.85899 3.93119 9.61882 3.7508 9.13832 3.39001C7.96667 2.51009 6.01623 1.95769 3.78152 3.32846C0.848716 5.12745 0.185092 11.0624 6.94993 16.0695C8.23842 17.0232 8.88266 17.5 10.0003 17.5C11.118 17.5 11.7622 17.0232 13.0507 16.0695C19.8156 11.0624 19.1519 5.12745 16.2192 3.32846Z"
        stroke="#A7A7A7"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

// ------- Faqs-Icon ------- //
export const FAQIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.3333 6.07207C18.3333 8.27338 16.4676 10.0582 14.1667 10.0582C13.8961 10.0586 13.6263 10.0336 13.3606 9.98364C13.1692 9.94772 13.0736 9.9298 13.0068 9.93997C12.9401 9.95014 12.8454 10.0005 12.6562 10.1011C12.1208 10.3858 11.4966 10.4864 10.8962 10.3747C11.1244 10.0941 11.2803 9.7573 11.349 9.3963C11.3907 9.17547 11.2875 8.96097 11.1328 8.80397C10.4305 8.09075 10 7.12972 10 6.07207C10 3.87075 11.8657 2.08594 14.1667 2.08594C16.4676 2.08594 18.3333 3.87075 18.3333 6.07207Z"
        stroke="#A7A7A7"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12.9102 6.25H12.9169M15.4102 6.25H15.4169"
        stroke="#A7A7A7"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M6.2519 17.9195H3.93213C3.66273 17.9195 3.39217 17.8815 3.14472 17.7752C2.33921 17.4291 1.93053 16.9721 1.74007 16.6862C1.63169 16.5236 1.64713 16.3164 1.76471 16.1602C2.69796 14.9206 4.86571 14.172 6.25587 14.1719C7.64603 14.172 9.80983 14.9206 10.7431 16.1602C10.8607 16.3164 10.8761 16.5236 10.7677 16.6862C10.5772 16.9721 10.1686 17.4291 9.36308 17.7752C9.11558 17.8815 8.84508 17.9195 8.57566 17.9195H6.2519Z"
        stroke="#A7A7A7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.57069 9.82618C8.57069 11.1023 7.53394 12.1368 6.25506 12.1368C4.97619 12.1368 3.93945 11.1023 3.93945 9.82618C3.93945 8.55009 4.97619 7.51562 6.25506 7.51562C7.53394 7.51562 8.57069 8.55009 8.57069 9.82618Z"
        stroke="#A7A7A7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// ------- All-Icon ------- //
export const AllIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={48}
      height={48}
      color={"#8C8C8C"}
      fill={"none"}
    >
      <path
        d="M10 6C10 3.79086 8.20914 2 6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M10 18C10 15.7909 8.20914 14 6 14C3.79086 14 2 15.7909 2 18C2 20.2091 3.79086 22 6 22C8.20914 22 10 20.2091 10 18Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M22 6C22 3.79086 20.2091 2 18 2C15.7909 2 14 3.79086 14 6C14 8.20914 15.7909 10 18 10C20.2091 10 22 8.20914 22 6Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M22 18C22 15.7909 20.2091 14 18 14C15.7909 14 14 15.7909 14 18C14 20.2091 15.7909 22 18 22C20.2091 22 22 20.2091 22 18Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

// ------- In-Progress-Icon ------- //
export const InProgressIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={48}
      height={48}
      color={"#8C8C8C"}
      fill={"none"}
    >
      <path
        d="M18.001 20C16.3295 21.2558 14.2516 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 12.8634 21.8906 13.7011 21.6849 14.5003C21.4617 15.3673 20.5145 15.77 19.6699 15.4728C18.9519 15.2201 18.6221 14.3997 18.802 13.66C18.9314 13.1279 19 12.572 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19C13.3197 19 14.554 18.6348 15.6076 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const NewIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={48}
      height={48}
      fill="none"
    >
      <path
        d="M9 16.5C8.38635 16.5 7.80015 16.2524 6.6277 15.7571C3.70923 14.5243 2.25 13.9079 2.25 12.871C2.25 12.5807 2.25 7.54838 2.25 5.25M9 16.5C9.61365 16.5 10.1999 16.2524 11.3723 15.7571C14.2908 14.5243 15.75 13.9079 15.75 12.871V5.25M9 16.5V8.5161"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.24444 7.26853L4.05354 6.20839C2.85118 5.62658 2.25 5.33567 2.25 4.875C2.25 4.41433 2.85118 4.12342 4.05354 3.54161L6.24444 2.48146C7.5966 1.82716 8.27273 1.5 9 1.5C9.72727 1.5 10.4034 1.82715 11.7556 2.48146L13.9465 3.54161C15.1488 4.12342 15.75 4.41433 15.75 4.875C15.75 5.33567 15.1488 5.62658 13.9465 6.20839L11.7556 7.26853C10.4034 7.92285 9.72727 8.25 9 8.25C8.27273 8.25 7.5966 7.92285 6.24444 7.26853Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 9L6 9.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 3L5.25 6.75"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// ------- Cancelled-Icon ------- //
export const CancelledIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={48}
      height={48}
      color={"#8C8C8C"}
      fill={"none"}
    >
      <path
        d="M14.9994 15L9 9M9.00064 15L15 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

// ------- Delivered-Icon ------- //
export const DeliveredIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={48}
      height={48}
      color={"#8C8C8C"}
      fill={"none"}
    >
      <path
        d="M15 2.4578C14.053 2.16035 13.0452 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 10.9548 21.8396 9.94704 21.5422 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8.5 9.5L12 13L21.0002 3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// ------- Eye-Icon ------- //
export const EyeIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.3347 3.92969C4.98176 3.92969 3.08622 5.96825 2.25523 7.18396C2.08901 7.42499 2 7.71085 2 8.00364C2 8.29642 2.08901 8.58229 2.25523 8.82332C3.08622 10.039 4.98176 12.0776 8.3347 12.0776C11.6876 12.0776 13.5832 10.039 14.4142 8.82332C14.5804 8.58229 14.6694 8.29642 14.6694 8.00364C14.6694 7.71085 14.5804 7.42499 14.4142 7.18396C13.5832 5.96825 11.6876 3.92969 8.3347 3.92969ZM13.6674 8.31187C12.9368 9.38003 11.2721 11.1715 8.3347 11.1715C5.39725 11.1715 3.73255 9.38003 3.00204 8.31187C2.93761 8.22183 2.90298 8.1139 2.90298 8.00319C2.90298 7.89248 2.93761 7.78454 3.00204 7.69451C3.73346 6.62634 5.39725 4.83491 8.3347 4.83491C11.2721 4.83491 12.9368 6.62634 13.6674 7.69451C13.7318 7.78454 13.7664 7.89248 13.7664 8.00319C13.7664 8.1139 13.7318 8.22183 13.6674 8.31187ZM8.3347 6.19274C7.33624 6.19274 6.52426 7.00473 6.52426 8.00319C6.52426 9.00165 7.33624 9.81363 8.3347 9.81363C9.33316 9.81363 10.1451 9.00165 10.1451 8.00319C10.1451 7.00473 9.33316 6.19274 8.3347 6.19274ZM8.3347 8.90841C8.10162 8.89798 7.88155 8.79806 7.7203 8.62944C7.55906 8.46081 7.46906 8.2365 7.46906 8.00319C7.46906 7.76988 7.55906 7.54556 7.7203 7.37694C7.88155 7.20832 8.10162 7.10839 8.3347 7.09796C8.56778 7.10839 8.78785 7.20832 8.94909 7.37694C9.11034 7.54556 9.20033 7.76988 9.20033 8.00319C9.20033 8.2365 9.11034 8.46081 8.94909 8.62944C8.78785 8.79806 8.56778 8.89798 8.3347 8.90841Z"
        fill="#3C3C3C"
      />
    </svg>
  );
};

// ------- EditNote-Icon ------- //
export const EditNoteIcon = ({size=16}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4653_166544)">
      <path
        d="M12.542 6.66669C12.6436 6.66671 12.7439 6.64349 12.8352 6.59881C12.9265 6.55413 13.0064 6.48916 13.0687 6.40887C13.1311 6.32859 13.1742 6.23512 13.1949 6.1356C13.2156 6.03608 13.2132 5.93315 13.188 5.83469C12.9804 5.02312 12.5583 4.28235 11.966 3.69002L9.64267 1.36669C9.21031 0.931991 8.69602 0.587375 8.12957 0.352785C7.56312 0.118196 6.95577 -0.00170678 6.34267 1.8354e-05H3.33267C2.449 0.00107726 1.60184 0.352628 0.977049 0.977539C0.352263 1.60245 0.000882152 2.44968 0 3.33335L0 12.6667C0 14.5047 1.49533 16 3.33333 16H5.33333C5.51014 16 5.67971 15.9298 5.80474 15.8048C5.92976 15.6797 6 15.5102 6 15.3334C6 15.1565 5.92976 14.987 5.80474 14.8619C5.67971 14.7369 5.51014 14.6667 5.33333 14.6667H3.33333C2.23067 14.6667 1.33333 13.7694 1.33333 12.6667V3.33335C1.33333 2.23069 2.23067 1.33335 3.33333 1.33335H6.34333C6.452 1.33335 6.56 1.33869 6.66667 1.34869V4.66669C6.66667 5.76935 7.564 6.66669 8.66667 6.66669H12.542ZM8 4.66669V1.77269C8.25267 1.91802 8.488 2.09802 8.7 2.31002L11.0233 4.63335C11.2327 4.84269 11.412 5.07869 11.5587 5.33335H8.66667C8.29933 5.33335 8 5.03402 8 4.66669ZM15.4147 7.91935C14.6587 7.16335 13.3413 7.16335 12.586 7.91935L8.11467 12.3907C7.86624 12.6378 7.66927 12.9317 7.53515 13.2555C7.40104 13.5792 7.33244 13.9263 7.33333 14.2767V15.334C7.33333 15.5108 7.40357 15.6804 7.5286 15.8054C7.65362 15.9304 7.82319 16.0007 8 16.0007H9.05733C9.40764 16.0016 9.75465 15.933 10.0783 15.7989C10.4019 15.6648 10.6957 15.4678 10.9427 15.2194L15.414 10.748C15.792 10.37 16 9.86802 16 9.33335C16 8.79869 15.792 8.29669 15.4147 7.91935ZM14.4713 9.80469L9.99933 14.276C9.87593 14.4003 9.72904 14.4989 9.56721 14.566C9.40538 14.633 9.23184 14.6673 9.05667 14.6667H8.666V14.276C8.666 13.92 8.80467 13.5854 9.05667 13.3334L13.5287 8.86202C13.6556 8.74067 13.8244 8.67294 14 8.67294C14.1756 8.67294 14.3444 8.74067 14.4713 8.86202C14.5973 8.98735 14.6667 9.15469 14.6667 9.33335C14.6667 9.51202 14.5973 9.67869 14.4713 9.80469Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_4653_166544">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

// ------- Three-Dot-Icon ------- //
export const ThreeDotIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9989 10.9018C11.1541 10.9018 10.4629 11.593 10.4629 12.4378C10.4629 13.2826 11.1541 13.9738 11.9989 13.9738C12.8437 13.9738 13.5349 13.2826 13.5349 12.4378C13.5349 11.593 12.8437 10.9018 11.9989 10.9018ZM11.9989 17.0458C11.1541 17.0458 10.4629 17.737 10.4629 18.5818C10.4629 19.4266 11.1541 20.1178 11.9989 20.1178C12.8437 20.1178 13.5349 19.4266 13.5349 18.5818C13.5349 17.737 12.8437 17.0458 11.9989 17.0458ZM11.9989 7.82981C12.8437 7.82981 13.5349 7.13861 13.5349 6.29381C13.5349 5.44901 12.8437 4.75781 11.9989 4.75781C11.1541 4.75781 10.4629 5.44901 10.4629 6.29381C10.4629 7.13861 11.1541 7.82981 11.9989 7.82981Z"
        fill="black"
      />
    </svg>
  );
};

// ------- Trash-Icon ------- //
export const TrashIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.8746 8.00156C8.8746 7.5045 8.47165 7.10156 7.9746 7.10156C7.47754 7.10156 7.0746 7.5045 7.0746 8.00156H8.8746ZM7.0746 16.0016C7.0746 16.4987 7.47754 16.9016 7.9746 16.9016C8.47165 16.9016 8.8746 16.4987 8.8746 16.0016H7.0746ZM13.1202 8.00156C13.1202 7.5045 12.7173 7.10156 12.2202 7.10156C11.7232 7.10156 11.3202 7.5045 11.3202 8.00156H13.1202ZM11.3202 16.0016C11.3202 16.4987 11.7232 16.9016 12.2202 16.9016C12.7173 16.9016 13.1202 16.4987 13.1202 16.0016H11.3202ZM2.66758 4.10156C2.17052 4.10156 1.76758 4.5045 1.76758 5.00156C1.76758 5.49862 2.17052 5.90156 2.66758 5.90156V4.10156ZM17.5272 5.90156C18.0243 5.90156 18.4272 5.49862 18.4272 5.00156C18.4272 4.5045 18.0243 4.10156 17.5272 4.10156V5.90156ZM5.48249 5.00156C5.48249 5.49862 5.88544 5.90156 6.38249 5.90156C6.87955 5.90156 7.28249 5.49862 7.28249 5.00156H5.48249ZM7.0746 8.00156V16.0016H8.8746V8.00156H7.0746ZM11.3202 8.00156V16.0016H13.1202V8.00156H11.3202ZM15.5658 5.00156V15.8016H17.3658V5.00156H15.5658ZM13.0694 18.1016H7.12547V19.9016H13.0694V18.1016ZM2.82898 5.00156V15.8016H4.62898V5.00156H2.82898ZM7.12547 18.1016C6.51703 18.1016 6.11171 18.101 5.80029 18.077C5.49791 18.0537 5.36143 18.0125 5.27755 17.9723L4.49857 19.595C4.86878 19.7727 5.25656 19.8405 5.66214 19.8717C6.05869 19.9022 6.54503 19.9016 7.12547 19.9016V18.1016ZM2.82898 15.8016C2.82898 16.3459 2.8282 16.8116 2.86127 17.193C2.8954 17.5865 2.97049 17.9712 3.16871 18.3377L4.752 17.4815C4.71885 17.4202 4.67825 17.3109 4.65454 17.0374C4.62977 16.7518 4.62898 16.3774 4.62898 15.8016H2.82898ZM5.27755 17.9723C5.04271 17.8595 4.86186 17.6846 4.752 17.4815L3.16871 18.3377C3.4659 18.8872 3.93454 19.3242 4.49857 19.595L5.27755 17.9723ZM15.5658 15.8016C15.5658 16.3774 15.5651 16.7518 15.5403 17.0374C15.5166 17.3109 15.476 17.4202 15.4428 17.4814L17.0261 18.3377C17.2243 17.9712 17.2994 17.5865 17.3336 17.193C17.3666 16.8116 17.3658 16.3459 17.3658 15.8016H15.5658ZM13.0694 19.9016C13.6498 19.9016 14.1361 19.9022 14.5327 19.8717C14.9383 19.8405 15.3261 19.7727 15.6963 19.595L14.9173 17.9723C14.8334 18.0125 14.6969 18.0537 14.3945 18.077C14.0831 18.101 13.6778 18.1016 13.0694 18.1016V19.9016ZM15.4428 17.4814C15.333 17.6845 15.1521 17.8595 14.9173 17.9723L15.6963 19.595C16.2603 19.3242 16.7289 18.8872 17.0261 18.3377L15.4428 17.4814ZM2.66758 5.90156H3.72898V4.10156H2.66758V5.90156ZM3.72898 5.90156H16.4658V4.10156H3.72898V5.90156ZM16.4658 5.90156H17.5272V4.10156H16.4658V5.90156ZM7.28249 4.20156C7.28249 3.05264 8.41206 1.90156 10.0974 1.90156V0.101562C7.67937 0.101562 5.48249 1.81586 5.48249 4.20156H7.28249ZM10.0974 1.90156C11.7828 1.90156 12.9123 3.05264 12.9123 4.20156H14.7123C14.7123 1.81586 12.5155 0.101562 10.0974 0.101562V1.90156ZM5.48249 4.20156V5.00156H7.28249V4.20156H5.48249Z"
        fill="#3C3C3C"
      />
    </svg>
  );
};

// ------- ImagePlus-Icon ------- //
export const ImagePlusIcon = () => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 8.9375C28.5177 8.9375 28.9375 8.51776 28.9375 8C28.9375 7.48224 28.5177 7.0625 28 7.0625V8.9375ZM18 7.0625C17.4822 7.0625 17.0625 7.48224 17.0625 8C17.0625 8.51776 17.4822 8.9375 18 8.9375V7.0625ZM23.9375 3C23.9375 2.48224 23.5177 2.0625 23 2.0625C22.4823 2.0625 22.0625 2.48224 22.0625 3H23.9375ZM22.0625 13C22.0625 13.5177 22.4823 13.9375 23 13.9375C23.5177 13.9375 23.9375 13.5177 23.9375 13H22.0625ZM28 7.0625H23V8.9375H28V7.0625ZM23 7.0625H18V8.9375H23V7.0625ZM22.0625 3V8H23.9375V3H22.0625ZM22.0625 8V13H23.9375V8H22.0625Z"
        fill="white"
      />
      <path
        d="M14.875 4.25C9.27707 4.25 6.47811 4.25 4.73905 5.98905C3 7.72811 3 10.5271 3 16.125C3 21.7229 3 24.5219 4.73905 26.261C6.47811 28 9.27707 28 14.875 28C20.4729 28 23.2719 28 25.011 26.261C26.75 24.5219 26.75 21.7229 26.75 16.125V15.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M3 18.1692C3.77377 18.0568 4.55605 18.0013 5.33964 18.0033C8.65456 17.9332 11.8883 18.9661 14.4639 20.9177C16.8525 22.7276 18.5309 25.2186 19.25 28"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M26.75 21.6202C25.2807 20.8761 23.761 20.4984 22.2327 20.5001C19.9181 20.4909 17.6269 21.3416 15.5 22.9999"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// ------- Star-Icon ------- //
export const StarIcon = ({ color = "#BEBCBD" }) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5394_34886)">
        <path
          d="M27.2558 10.0165L18.6481 8.70169L14.79 0.483687C14.5018 -0.129979 13.495 -0.129979 13.2068 0.483687L9.3498 8.70169L0.742138 10.0165C0.583211 10.0409 0.434085 10.1087 0.311132 10.2123C0.18818 10.3159 0.0961562 10.4514 0.045165 10.6039C-0.00582629 10.7564 -0.0138131 10.92 0.0220814 11.0767C0.0579759 11.2334 0.136364 11.3773 0.248638 11.4924L6.50197 17.902L5.02381 26.9635C4.99741 27.1256 5.01715 27.2918 5.08076 27.4432C5.14437 27.5945 5.24928 27.725 5.38352 27.8195C5.51775 27.9141 5.67588 27.9689 5.83982 27.9779C6.00377 27.9868 6.16693 27.9494 6.31064 27.87L13.999 23.621L21.6873 27.8712C21.831 27.9506 21.9942 27.988 22.1581 27.979C22.3221 27.9701 22.4802 27.9152 22.6144 27.8207C22.7487 27.7261 22.8536 27.5957 22.9172 27.4443C22.9808 27.293 23.0005 27.1267 22.9741 26.9647L21.496 17.9032L27.7493 11.4935C27.8619 11.3785 27.9406 11.2346 27.9767 11.0777C28.0128 10.9208 28.0049 10.7569 27.9538 10.6042C27.9028 10.4515 27.8107 10.3159 27.6875 10.2122C27.5643 10.1085 27.415 10.0408 27.2558 10.0165Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5394_34886">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

// ------- X-Circle-Icon ------- //
export const XCircleIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="14" height="14" rx="7" fill="#3C3C3C" />
      <g clipPath="url(#clip0_4653_180005)">
        <path
          d="M4.29302 3.99996C4.23507 3.99995 4.17842 4.01713 4.13023 4.04932C4.08204 4.08151 4.04448 4.12727 4.0223 4.18081C4.00013 4.23435 3.99432 4.29326 4.00563 4.3501C4.01694 4.40694 4.04485 4.45915 4.08584 4.50012L9.4999 9.91418C9.55485 9.96913 9.62938 10 9.70709 10C9.7848 10 9.85932 9.96913 9.91427 9.91418C9.96922 9.85923 10.0001 9.7847 10.0001 9.70699C10.0001 9.62928 9.96922 9.55475 9.91427 9.49981L4.50021 4.08574C4.47303 4.0585 4.44073 4.0369 4.40518 4.02218C4.36962 4.00746 4.33151 3.99991 4.29302 3.99996Z"
          fill="#F6F6F6"
        />
        <path
          d="M9.70707 3.99996C9.66859 3.99991 9.63047 4.00746 9.59492 4.02218C9.55936 4.0369 9.52707 4.0585 9.49988 4.08574L4.08582 9.49981C4.03087 9.55475 4 9.62928 4 9.70699C4 9.7847 4.03087 9.85923 4.08582 9.91418C4.14077 9.96913 4.2153 10 4.29301 10C4.37072 10 4.44525 9.96913 4.50019 9.91418L9.91426 4.50012C9.95524 4.45915 9.98315 4.40694 9.99446 4.3501C10.0058 4.29326 9.99997 4.23435 9.97779 4.18081C9.95561 4.12727 9.91805 4.08151 9.86986 4.04932C9.82167 4.01713 9.76502 3.99995 9.70707 3.99996Z"
          fill="#F6F6F6"
        />
      </g>
      <defs>
        <clipPath id="clip0_4653_180005">
          <rect
            width="6"
            height="6"
            fill="white"
            transform="matrix(1 0 0 -1 4 10)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

// ------- Camero-Plus-Icon ------- //
export const CameroPlusIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.8733 1.78906C17.691 1.78906 17.5161 1.8615 17.3872 1.99043C17.2582 2.11936 17.1858 2.29423 17.1858 2.47656V3.70994H15.9531C15.7708 3.70994 15.5959 3.78237 15.467 3.9113C15.3381 4.04023 15.2656 4.2151 15.2656 4.39744C15.2656 4.57977 15.3381 4.75464 15.467 4.88357C15.5959 5.01251 15.7708 5.08494 15.9531 5.08494H17.1858V6.31763C17.1858 6.49996 17.2582 6.67483 17.3872 6.80376C17.5161 6.93269 17.691 7.00513 17.8733 7.00513C18.0556 7.00513 18.2305 6.93269 18.3594 6.80376C18.4884 6.67483 18.5608 6.49996 18.5608 6.31763V5.08494H19.7935C19.9758 5.08494 20.1507 5.01251 20.2796 4.88357C20.4086 4.75464 20.481 4.57977 20.481 4.39744C20.481 4.2151 20.4086 4.04023 20.2796 3.9113C20.1507 3.78237 19.9758 3.70994 19.7935 3.70994H18.5608V2.47656C18.5608 2.29423 18.4884 2.11936 18.3594 1.99043C18.2305 1.8615 18.0556 1.78906 17.8733 1.78906Z"
        fill="#7A7A7A"
      />
      <path
        d="M17.875 8.37906C17.3518 8.37826 16.8486 8.17797 16.4679 7.81902C16.0872 7.46006 15.8577 6.96946 15.8263 6.44719C15.304 6.41569 14.8134 6.18622 14.4544 5.80555C14.0955 5.42488 13.8952 4.92166 13.8944 4.39844C13.8944 3.86219 14.0938 3.38094 14.4306 3.02344C13.86 2.59031 13.1381 2.33594 12.375 2.33594H9.625C7.96812 2.33594 6.5725 3.51844 6.25625 5.08594H4.8125C2.915 5.08594 1.375 6.62594 1.375 8.52344V16.7734C1.375 18.6709 2.915 20.2109 4.8125 20.2109H17.1875C19.085 20.2109 20.625 18.6709 20.625 16.7734V8.52344C20.625 7.74656 20.3638 7.02469 19.9237 6.44719C19.8923 6.96946 19.6628 7.46006 19.2821 7.81902C18.9014 8.17797 18.3982 8.37826 17.875 8.37906ZM11 17.4609C8.34625 17.4609 6.1875 15.3022 6.1875 12.6484C6.1875 9.99469 8.34625 7.83594 11 7.83594C13.6537 7.83594 15.8125 9.99469 15.8125 12.6484C15.8125 15.3022 13.6537 17.4609 11 17.4609Z"
        fill="#7A7A7A"
      />
      <path
        d="M11 16.0859C12.8985 16.0859 14.4375 14.5469 14.4375 12.6484C14.4375 10.75 12.8985 9.21094 11 9.21094C9.10152 9.21094 7.5625 10.75 7.5625 12.6484C7.5625 14.5469 9.10152 16.0859 11 16.0859Z"
        fill="#7A7A7A"
      />
    </svg>
  );
};
